import InsightsApiExport from 'components/insights/layout/InsightsApiExport';
import { InsightsQueryParams } from 'components/insights/query/useInsightsAnalytics';
import { getNetworkPerformanceAnalyticsFilters, useNetworkPerformanceStore } from 'stores/networkPerformanceStore';

type Props = {
  disabled?: boolean;
  filename?: string;
  show?: boolean;
  params: InsightsQueryParams;
};

export default function NetworkPerformanceApiExport(props: Props) {
  const analyticsFilters = useNetworkPerformanceStore((state) => getNetworkPerformanceAnalyticsFilters(state));

  return <InsightsApiExport {...props} analyticsFilters={analyticsFilters} />;
}
